export const endPoints = {
 apiBaseUrl:process.env.REACT_APP_API_BASE_URL,
 api: {
   LOGIN_ENDPOINT: "admin/login",
   VERIFY_USER_OTP: "admin/verifyOtp",
   SIGNUP: "users/signup",    //account-management1/users/signup
   GET_BY_USERID: "users/userid", // 12  Append userid
   GET_BY_USERNAME: "users/username/", // userrname
   UPDATE_PERSONAL: "users/personal",
   UPDATE_PROFILE_IMAGE: "upload/profileimage",
   EMAIL_SUPPORT: "email/support",
   VERIFICATION_ENDPOINT: "users/validate",
   STATES: "states",
   rgTypes:'rgTypes',
   accountstatus:'accountstatus',
   playertypes:'playertypes',
   kycstatus:'kycstatus',
   UPDATE_EMAIL: "users/email",
   FORGOT_PASSWORD: "users/passwordlost/",
   GET_SPORTS_DATA: "api/sports/id", //sportsid 6046
   DELETE_USER: 'users/delete',
   ADD_USER: 'users/add',
   GET_ADMIN: 'users/admin',
   GET_ALL_USERS: 'users',  ///'users/all',  replace to load 
   GET_RISKMANAGER: 'users/riskmanager',
   //admin api section
   GET_USERS: 'users',
   GET_BETS: 'bets/all',
   Get_Block_User: 'bolck/users',
   Create_Staff: 'staff/create',
   Update_Staff: 'staff/update',
   Delete_Staff: 'staff/delete',
   get_All_Staff: 'staffs',
   get_Single_Staff: 'staff',
   GET_Action_List: 'historicalSearch',
   GET_Access_List: 'sessionSearch',
   GET_QUESTIONS: 'questions',
   transactions: 'alltransactions',
   GET_DOCUMENTS: 'documentTypes',
   TRANSFER_SUMMARY_LIST: 'transfer/summary/list',
   TRANSFER_DETAIL_LIST: 'transfer/details/list',
   TRANSFER_SUMMARY_REPORT: 'transfer/summary/download',
   TRANSFER_DETAIL_REPORT: 'transfer/details/download',
   USERS_REPORT: 'users/download',
   USERS_BLOCK_REPORT: 'users/block/download',
   ACTION_REPORT: 'action/download',
   ACCESS_REPORT: 'access/download',
   GetUserLimit: 'user/limit/',
   SetUserLimit: 'user/limit',
   deposit: 'admin/transactions/deposit',
   withdraw: 'admin/transactions/withdrawal',
   fieldUpdate:'account/fieldupdate',
   userFieldUpdate:'user/fieldupdate',
   userSecret:'users/secret',
   userRGLimit:'user/rglimit',
   FANTASY_PROMO:'promo/get',
   FANTASY_ADD_PROMO:'promo/add',
   FANTASY_UPDATE_PROMO:'promo/update',
   GET_IMAGE:'promotions',
   ADD_IMAGE:'addpromotions',
   UPDATE_IMAGE:'updatepromotions',
   UPLOAD_BANNER:'upload/bannerimage',
   CREATE_NOTE:'note/create',
   GET_NOTES:'note/usernotes',
   DELETE_NOTE:'note/delete',
   UPDATE_NOTE:'note/update',
   GET_ALL_BONUS:'bonus/all',
   CREATE_BONUS:'bonus/create',
   UPDATE_BONUS:'bonus/update',
   GETPROVIDERS:'api/casino/providers',
   ADDPROVIDERS:'api/casino/addProvider',
   UPDATEPROVIDERS:'api/casino/updateProvider',
   DELETE_PROVIDERS:'api/casino/deleteProvider/',
   GETMENU:'api/casino/menu',
   ADDMENU:'api/casino/addMenu',
   UPDATEMENU:'api/casino/updateMenu',
   DELETE_MENU:'api/casino/deleteMenu/',
   GETGAMES:'api/casino/games',
   ADDGAMES:'api/casino/addGame',
   UPDATEGAMES:'api/casino/updateGame',
   DELETE_GAMES:'api/casino/deleteGame/',
   GETFEATUREGAMES:'api/casino/featuregames',
   ADD_FEATUREGAMES:'api/casino/addFeatureGame',
   UPDATE_FEATUREGAMES:'api/casino/updateFeatureGame',
   DELETE_FEATUREGAMES:'api/casino/deleteFeatureGame/',
   GET_PROMO:'api/casino/promosadmin',
   ADD_PROMO:'api/casino/addPromo',
   UPDATE_PROMO:'api/casino/updatePromo',
   DELETE_PROMO:'api/casino/deletePromo/',
   // Configurable promo-code system (PromoSystemController)
   PROMO_CAMPAIGN_ALL:'admin/promotions/all',
   PROMO_CAMPAIGN_ADD:'admin/promotions/add',
   PROMO_CAMPAIGN_UPDATE:'admin/promotions/update',
   PROMO_CAMPAIGN_DELETE:'admin/promotions/delete',      // + /{id}
   PROMO_CAMPAIGN_USAGE:'admin/promotions/usage',        // + /{id}
   // Survey / poll promotion (SurveyController)
   SURVEY_ALL:'admin/survey/all',
   SURVEY_ADD:'admin/survey/add',
   SURVEY_UPDATE:'admin/survey/update',
   SURVEY_DELETE:'admin/survey/delete',                  // + /{id}
   SURVEY_ACTIVE:'admin/survey/active',                  // + /{id}/{true|false}
   SURVEY_RESULTS:'admin/survey/results',                // + /{id}
   // UTM attribution (UtmController)
   UTM_REPORT_SUMMARY:'api/v1/utm/report/summary',
   UTM_REPORT_CAMPAIGNS:'api/v1/utm/report/campaigns',
   UTM_REPORT_REVENUE:'api/v1/utm/report/revenue',
   UTM_REPORT_SIGNUPS:'api/v1/utm/report/signups',
   // Visitor page-view analytics (VisitorAnalyticsController)
   ANALYTICS_LIST:'api/v1/analytics/list',
   // PWA install funnel (PwaController)
   PWA_REPORT_FUNNEL:'api/v1/pwa/report/funnel',
   PWA_REPORT_DAILY:'api/v1/pwa/report/daily',           // + ?days=30
   PWA_REPORT_PLATFORMS:'api/v1/pwa/report/platforms',
   GET_GIFT: 'api/casino/admingifts',          //'api/casino/gifts',
   ADD_GIFT:'api/casino/addGift',
   UPDATE_GIFT:'api/casino/updateGift',
   DELETE_GIFT:'api/casino/deleteGift/',
   GET_POPUP:'banner/all',
   ADD_POPUP:'banner/add',
   UPDATE_POPUP:'banner/update',
   GET_PACKAGE:'admin/packages',
   ADD_PACKAGE:'api/casino/addcoinpackage',
   UPDATE_PACKAGE:'api/casino/updatecoinpackage',
   DELETE_PACKAGE:'api/casino/deletePackage/',
   POPUP_OFFER_ALL:'popupOffer/all',
   POPUP_OFFER_ADD:'popupOffer/add',
   POPUP_OFFER_UPDATE:'popupOffer/update',
   POPUP_OFFER_DELETE:'popupOffer/delete',
   POPUP_SEG_GET:'popupSegmentation/all',
   POPUP_SEG_SAVE:'popupSegmentation/save',
   POPUP_STATS:'popups/stats',
   GET_LOTTERY_PACKAGES:'admin/packages/lottery',
   GET_ALL_LOTTERY:'lottery/all',
   GET_LOTTERY_TICKETS:'lottery',
   CREATE_LOTTERY:'lottery/create',
   UPDATE_LOTTERY:'lottery/update',
   DELETE_LOTTERY:'lottery/delete',
   SETTLE_LOTTERY:'lottery/settle',
   GET_ALL_TOURNAMENTS:'tournament/admin/all',
   CREATE_TOURNAMENT:'tournament/admin/create',
   UPDATE_TOURNAMENT:'tournament/admin/update',
   DELETE_TOURNAMENT:'tournament/admin/delete', // + /{id}
   TOURNAMENT_ADMIN:'tournament/admin', // + /{id}/games | /{id}/players | /{id}/calculate | /{id}/settle
   LINK_ACCOUNT:'user/linkaccount',
   GET_LINK_ACCOUNT:'user/linkaccounts',
   DELETE_BANNER: 'promotion/delete',
   DELETE_MARKETING: 'banner/delete',
   GAMES_BY_PROVIDER:'api/casino/gamesbyprovider/',
   DELINK_ACCOUNT:'user/delete/linkaccount',
   COOL_OFF: 'user/cooloff',
   USER_EXCLUDE: 'user/exclude',
   playerStatus:'playerstatus',
   UPDATE_REDEMPTIONCLAIM:'api/casino/updatebuytrans',
   GET_REDEMPTIONCLAIM:'api/casino/giftstransaction',
   GET_PAYMENTS:'api/payments',
   WITHDRAW_TRANSACTIONS:'allwithdraw',
   TRANSACTION_UPDATE:'transactions/update',
   TRANSACTION_REGENERATE:'transactions/regenerate',
   UPDATE_CAMPAIGN:'api/campain/update',
   CREATE_CAMPAIGN:'api/campain/create',
   GET_ALL_CAMPAIGN: 'api/campain/get',
   UPDATE_COUPON:'api/coupon/update',
   CREATE_COUPON:'api/coupon/create',
   GET_ALL_COUPON: 'api/coupon/get',
   GET_ALL_TRACKING: '/api/coupon/used',
   GET_ALL_CAMPAIGN_USERS:'api/campain/users',
   GET_ALL_COUPON_USER:'api/coupon/users',
   DELETE_COUPON:'api/coupon/delete',
   DELETE_CAMPAIGN:'api/campain/delete',
   CREATE_BULK_BOUNS:'bonus/bulkadd',
   GET_ALL_ACTIVE_CAMPAIGN:"/api/campain/getactive",
   GET_TRANSACTION_DETAILS:"transactiondetails",

   GET_USER_TRANSACTION:'casinoplay/admingamelist',
   GET_COIN_TRANSACTION:'casinoskrill/payment/transactionsall',
   GET_COIN_TRANSACTION_CSV:'casinoskrill/payment/transactionsall/download/csv',
   GET_COIN_TRANSAC_Details:'casinoplay/admingamelist',

   DEPOSIT_COIN: 'admin/coin/deposit',
   WITHDRAW_COIN: 'admin/coin/withdrawal',
   USER_COIN_TRANSACTION:'admin/transaction/users',
   CASINO_GAME_LIST:'casinoplay/gamelist',
   USER_CASINO_UPDATE:'admin/user/update',
   REFER_USERS:'referUsers',
   PACKAGE_USER_TRANS:'casinoskrill/payment/transactions',
   ADD_COIN_PACKAGE:'/api/casino/user/addcoinpackage',
   PAYMENT_METHOD:'getPaymentMode',
   UPDATE_PAYMENT:'updatePaymentMode',
   CREATE_VIP_PACKAGE:'api/bench/createpackage',
   UPDATE_VIP_PACKAGE:'/api/bench/updatepackage',
   GET_VIP_PACKAGES:'api/bench/packages',
   CONFIGURATION:'api/configuration/all',
   CONFIGURATION_CREATE:"api/configuration/create",
   CONFIGURATION_UPDATE:'api/configuration/update',
   GIFT_CASH_TRANSACTION: "withdraw/",
   DELTE_VIP_PACKAGE:'api/bench/deletepackage',
   GET_SOCIAL_POST:'post/get',
   UPDATE_SOCIAL_POST:'post/update',
   GAME_CATEGORY:'api/games/getcategory',
   ADD_CATEGORY:'api/casino/insertgamecategory',
   UPDATA_CATEGORY:'api/casino/updategamecategory',
   GET_CATEGORY:'api/games/getcategory',
   MAIL_IN_LIST:'email/promo/get',
   DASHBOARD_GAME_LIST:'dashboard/usertransaction',
   DASHBOARD_GAME_TRANSACTION:'dashboard/gametransaction/',      // + {page}
   DASHBOARD_BIGGEST_WINNERS:'dashboard/biggestwinners/',        // + {count}
   SPINSAGA_GAMES:'api/selfgame/addGame',
   GET_SPINSAGA_GAMES:'api/selfgame/games',
   UPDATE_SPINSAGA_GAMES:'api/selfgame/updateGame',
  WITHDRAW_CARD_TRANSACTIONS:'allwithdrawCard',
  CARD_CASH_TRANSACTION_BY_USERID: "cardwithdraw/",
  TRANSACTION_UPDATE_FOR_CARD:'transactions/updateForCard',
   GET_WOF:'api/configuration/wof',
   UPDATE_WOF:'api/configuration/wof/update',
   GET_POPUP_WOF:'popupWof/all',
   UPDATE_POPUP_WOF:'popupWof/update',
   GET_ALL_PACKAGE:'api/casino/allpackages',
   WITHDRAW_CRYPTO_TRANSACTIONS:'allwithdrawCrypto',
   CRYPTO_TRANSACTION_BY_USERID:'cryptowithdraw/',
   ALLOW_CRYPTO:'/transactions/updateForCrypto',
   MONTHLY_REWARDS:'monthlyRewards/all',
   UPDATE_MONTHLY_REWARDS:'monthlyRewards/update',
   CREATE_MONTHLY_REWARDS:'monthlyRewards/create',
   DELETE_MONTHLY_REWARDS:'monthlyRewards/delete/',         // + {id}
   GET_REWARDS_BY_STREAK_TYPE:'monthlyRewards/all/',        // + {streakTypeId}
   MONTHLY_REWARD_CONFIG:'monthlyRewards/createConnfig',    // backend spelling
   GET_MONTHLY_REWARD_CONFIG:'monthlyRewards/configlist',
   GET_ALL_STREAK_TYPES:'streakType/all',
   ADMIN_RESET_USER_STREAK:'api/rewards/admin/reset-streak',
   CREATE_STREAK_TYPE:'streakType/create',
   UPDATE_STREAK_TYPE:'streakType/update',
   DELETE_STREAK_TYPE:'streakType/delete/',                 // + {id}
   SERACH_GAME: "api/casino/searchgames",
   SEARCH_FREESPIN_GAMES:'api/casino/searchFreeSpinGames',
   GAME_DETAILS:'api/casino/gamedetail',
    ADD_FREE_SPINS:'api/casino/admin/freespin',
   GET_FREE_SPINS:'admin/frespins',
      GET_KYC_LIST:'api/kyc/users/all',
   UPDATE_KYC_STATUS:'api/kyc/status',
   SAVE_KYC:'api/kyc/save',                 // upsert by idUser: documents + doc type
   UPLOAD_KYC_DOC:'upload/kycdoc',          // multipart "file" -> returns stored path
   GET_ERROR_LOG:'errorlog/all',
   GET_STATES:'api/casino/admin/states',
   GET_PACKAGE_AUDIT:'api/casino/admin/packageaudit',

   // Risk management. Player-facing risk reads need no admin session; everything
   // under admin/risk does, and the API rejects the call without the SessonId header.
   RISK_OVERVIEW: 'admin/risk/overview',
   RISK_PLAYERS: 'admin/risk/players',
   RISK_PLAYER_DETAIL: 'admin/risk/players/',   // append id_user
   RISK_EVENTS: 'admin/risk/events',
   RISK_REVIEW: 'admin/risk/players/',          // append id_user + '/review'
   RISK_BLOCK: 'admin/risk/players/',           // append id_user + '/block'
   RISK_RULES: 'admin/risk/rules',
   GET_ERROR_LOG_24H:'errorlog/last24hours',
   GET_SEGMENTS:'audience/segments',
   GET_BLOCK_DOMAIN:'admin/block-domain/list',
   ADD_BLOCK_DOMAIN:'admin/block-domain/add',
   DELETE_BLOCK_DOMAIN:'admin/block-domain/delete',

   GET_EXCHANGE_RATE:'api/exchange-rate/list',
   ADD_EXCHANGE_RATE:'api/exchange-rate/create',
   UPDATE_EXCHANGE_RATE:'api/exchange-rate/update',
   DELETE_EXCHANGE_RATE:'api/exchange-rate/',
   GET_TIERS:'api/exchange-rate/tiers',
   UPDATE_TIER_MULTIFACTOR:'api/exchange-rate/tier/multifactor',

   GET_HAPPY_HOURS:'happyHour/all',
   GET_HAPPY_HOUR:'happyHour/get/', // append id
   ADD_HAPPY_HOUR:'happyHour/create',
   UPDATE_HAPPY_HOUR:'happyHour/update',
   DELETE_HAPPY_HOUR:'happyHour/delete/', // append id




 },
 mode: "Development",
};

export const paymentEndpoints = {
 apiBaseUrl: process.env.REACT_APP_API_BASE_URL_PAYMENT,
 api: {
   ACTIVATE: "payment/enroll",
   TRANSACTION_SUMMARY_LIST: 'transaction/summary',
   TRANSACTION_DETAIL_LIST: 'transaction/detailed',
   TRANSACTION_SUMMARY_REPORT: 'transaction/summary/download',
   TRANSACTION_DETAIL_REPORT: 'transaction/detailed/download',
   deposit_WithDraw: 'payment/transfers',
   GET_COIN_FEE:"api/casino/getFeesEstimateAll",
   SEARCH_COIN_FEE:"api/casino/getFeesEstimate",

 }
}

export const sportEndPoint = {
 apiBaseUrl:  process.env.REACT_APP_API_BASE_URL_SPORT,
 api: {
   leagueByIdUrl: "api/league/",
   leagueList: "api/leagues",
   sports: "api/sports/",
   GET_BETS: 'api/fantasy/all',
   EXPORT_BET_PDF: 'api/fantasy/download/pdf',
   EXPORT_BET_CSV: 'api/fantasy/download/csv',
   REPORT: 'api/fantasy/report',
   LIVE_BET_REPORT: 'api/fantasy/report/live',
   LIVE_BET_SUMMARY: 'api/fantasy/summary',
   all_bets: "api/fantasy/info",
 },
 mode: "Development",
};

export  const  DefaultImageBaseurl = 'https://cdn.spinsagacasino.com:5000/'

// Player-facing site that admin-generated player links point at (e.g. the
// email-package buy-coins URL). Unlike the API base URLs above this one takes
// NO trailing slash — paths are appended as `${PlayerSiteUrl}/buy-coins` — so
// any trailing slash from the env file is trimmed here.
export const PlayerSiteUrl = (
  process.env.REACT_APP_PLAYER_SITE_URL || 'https://play.spinsagacasino.com'
).replace(/\/+$/, '');

export default {};

